import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BusinessIcon from "@mui/icons-material/Business";
import ContactsIcon from "@mui/icons-material/Contacts";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import PageviewIcon from "@mui/icons-material/Pageview";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import StoreIcon from "@mui/icons-material/Store";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { BRAND_BLUE, BRAND_GREEN } from "../theme/colors";

// ⭐ NEW ICON
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const BLUE_DARK = BRAND_BLUE;
const BLUE_MID = "#0A4C95";
const BLUE_BRIGHT = "#2A6FB6";
const BLUE_SOFT = "#5B8FC4";
const BLUE_PALE = "#7EA8D6";

const GREEN_DARK = BRAND_GREEN;
const GREEN_MID = "#7E9A2E";
const GREEN_BRIGHT = "#90AA42";
const GREEN_SOFT = "#A6BA66";
const GREEN_DEEP = "#556F12";

export const NAV_OPTIONS = [
  // =====================================================
  // CORE (ALWAYS VISIBLE)
  // =====================================================
  {
    label: "Home",
    value: "/home",
    Icon: HomeOutlinedIcon,
    rowColor: BLUE_DARK,
    iconColor: "#00336C",
    access: null,
  },

  // =====================================================
  // EMAIL
  // =====================================================
  {
    label: "Outlook",
    value: "/outlook",
    Icon: MailOutlineIcon,
    rowColor: BLUE_BRIGHT,
    iconColor: BRAND_GREEN,
    access: "email.outlook",
  },

  // =====================================================
  // SHARED / ALWAYS AVAILABLE
  // =====================================================
  {
    label: "Metrics",
    value: "/metrics",
    Icon: AssessmentIcon,
    rowColor: GREEN_MID,
    iconColor: "#D4A62A",
    access: null,
  },

  // =====================================================
  // SHARED CRM SURFACE (BRE + PROSPECTING)
  // =====================================================
  {
    label: "Companies",
    value: "/bre-companies",
    Icon: BusinessIcon,
    rowColor: GREEN_BRIGHT,
    iconColor: "#1976D2",
    access: ["bre.companies", "prospecting.companies"],
  },
  {
    label: "Contacts",
    value: "/bre-contacts",
    Icon: ContactsIcon,
    rowColor: BLUE_MID,
    iconColor: "#9C27B0",
    access: ["bre.contacts", "prospecting.contacts"],
  },

  // =====================================================
  // PROJECTS (ALWAYS AVAILABLE)
  // =====================================================
  {
    label: "Projects",
    value: "/projects",
    Icon: WorkHistoryIcon,
    rowColor: GREEN_DARK,
    iconColor: "#4CAF50",
    access: null,
  },
  {
    label: "Research",
    value: "/research",
    Icon: TravelExploreIcon,
    rowColor: BLUE_SOFT,
    iconColor: "#2E8B7A",
    access: null,
  },

  // =====================================================
  // BRE ONLY
  // =====================================================
  {
    label: "Membership",
    value: "/membership",
    Icon: CardMembershipIcon,
    rowColor: GREEN_SOFT,
    iconColor: "#D4A62A",
    access: "bre.membership",
  },
  {
    label: "Incubators",
    value: "/incubators",
    Icon: RocketLaunchIcon,
    rowColor: GREEN_DEEP,
    iconColor: "#648315",
    access: "bre.incubators",
  },
  {
    label: "Surveys",
    value: "/surveys",
    Icon: AssignmentIcon,
    rowColor: GREEN_SOFT,
    iconColor: "#E91E63",
    access: "bre.surveys",
  },

  // =====================================================
  // PROSPECTING ONLY
  // =====================================================
  {
    label: "Inquiries",
    value: "/inquiries",
    Icon: HelpOutlineIcon,
    rowColor: BLUE_PALE,
    iconColor: "#FF9800",
    access: "prospecting.inquiries",
  },
  {
    label: "Trade Shows",
    value: "/tradeshows",
    Icon: CalendarMonthIcon,
    rowColor: GREEN_BRIGHT,
    iconColor: "#009688",
    access: "prospecting.trade_shows",
  },
  {
    label: "Website Visits",
    value: "/website-visits",
    Icon: PageviewIcon,
    rowColor: BLUE_BRIGHT,
    iconColor: "#1565C0",
    access: "prospecting.website_visits",
  },
  {
    label: "Site Consultants",
    value: "/site-consultants",
    Icon: LocationOnIcon,
    rowColor: BLUE_SOFT,
    iconColor: "#1B5E20",
    access: "prospecting.site_consultants",
  },
  {
    label: "AI Prospecting",
    value: "/ai-prospecting",
    Icon: AutoAwesomeIcon,
    rowColor: GREEN_MID,
    iconColor: BRAND_GREEN,
    access: "prospecting.weekly_prospects",
  },

  // =====================================================
  // OTHER
  // =====================================================
  {
    label: "Economic Impact",
    value: "/fiscal-impact",
    Icon: QueryStatsIcon,
    rowColor: GREEN_SOFT,
    iconColor: "#5B3E96",
    access: "other.fiscal_impact",
  },
  {
    label: "Retail",
    value: "/retail",
    Icon: StoreIcon,
    rowColor: BLUE_PALE,
    iconColor: "#A65A00",
    access: "other.retail",
  },
  {
    label: "Geographic Targeting",
    value: "/geographic-targeting",
    Icon: MapIcon,
    rowColor: GREEN_SOFT,
    iconColor: "#0F766E",
    access: "other.geographic-targeting",
  },
  {
    label: "Property Management",
    value: "/properties",
    Icon: ApartmentOutlinedIcon,
    rowColor: BLUE_MID,
    iconColor: "#1976D2",
    access: "other.property_management",
  },
];
